import Stack, { StackProps } from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

import LoadingOrValue from "@covertree/ui/loading/LoadingOrValue";
import IconButton from "@covertree/ui/buttons/IconButton";
import { mapPolicyType } from "@redux/residents/utils";
import { Resident } from "@graphql/api";

import InsuranceAdoptionStatusText from "../InsuranceAdoptionStatusText";

interface Props extends StackProps {
  isLoading?: boolean;
  onClose(): void;
  resident?: Resident;
  showResident?: boolean;
}

export default function DetailsDrawerTop({
  isLoading,
  onClose,
  resident,
  showResident = true,
  ...props
}: Props) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      {...props}>
      <Stack direction="row" spacing={1}>
        {showResident && (
          <>
            <InsuranceAdoptionStatusText
              status={resident?.insuranceAdoption.status}
              isLoading={isLoading}
            />
            <Typography sx={{ color: "text.disabled" }}>
              <LoadingOrValue
                loading={!resident && isLoading}
                value={`• ${mapPolicyType(
                  resident?.policyType,
                  resident?.insuranceAdoption.status
                )}`}
                height={28}
                width={120}
              />
            </Typography>
          </>
        )}
      </Stack>
      <IconButton onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Stack>
  );
}
